module.exports = __webpack_public_path__ + "static/media/eproxy-placeholder.f60622bc.png";